@use '@lib/assets/styles/main.scss' as *;

.root {
  border-radius: 10px;
  border: 1px solid $blue500;
  background: $gray0;
  padding: 16px 24px;
  display: grid;
  grid-column-gap: 16px;
  align-items: center;
  margin-bottom: 16px;
  @include responsive($md1) {
    grid-template-columns: min-content minmax(0, auto) min-content;
  }
  @include responsive(null, $md1) {
    grid-row-gap: 16px;
    grid-template-columns: 1fr;
    grid-template-rows: min-content min-content min-content;
  }
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid $gray0;
  background: linear-gradient(225deg, $blue20 0%, $blueLight 100%);
  box-shadow: 0 1px 3px rgba(30, 26, 199, 0.15);
  width: 48px;
  height: 48px;
  svg {
    display: block;
    width: 28px;
    height: 28px;
  }
}

.content {
  display: block;
}

.title {
  margin-bottom: 4px;
}

.desc {
  color: $gray400;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-self: end;
}
